module.exports = {
  NAVIGATION_MODE: {
    HORIZONTAL: 'HORIZONTAL',
    VERTICAL: 'VERTICAL'
  },
  NODE_TYPE: {
    ROOT: 'ROOT',
    NODE: 'NODE',
    LEAF: 'LEAF'
  }
}
